(function () {
    'use strict';

    angular
        .module('sodDocumentLibrary')
        .directive('documentLibraryUpload', documentLibraryUpload);

    function documentLibraryUpload() {
        return {
            restrict: 'E',
            scope: {
                options: '=',
            },
            controller: documentLibraryUploadCtrl,
            controllerAs: 'vm',
            bindToController: true,
            template: '<div class="document-library-upload" ng-if="vm.uploadOptions">' +
            '<input type="file" kendo-upload="vm.uploadObj" k-options="vm.uploadOptions" ng-init="vm.quanKunDaMoYi()" />' +
            '</div>',
            link: documentLibraryUploadLink
        };

        function documentLibraryUploadLink(scope, elem) {

        }
    }

    function documentLibraryUploadCtrl(lodash, $timeout, $element, CommonHelper) {
        const vm = this;

        this.$onInit = function() {
            vm.quanKunDaMoYi = quanKunDaMoYi; // 乾坤大挪移 shifting things around.

            $timeout(function () {
                init();
                console.log('vm.options', vm.options, vm.uploadOptions);
            });

            function init() {
                vm.uploadOptions = angular.merge(
                    {},
                    vm.options,
                    lodash.get(vm.options, 'config', {}),
                    {
                        uploadEvent: function(e) {
                            if (lodash.has(vm.onLoadEventOptions, 'fileSize')) {
                                var fileSize = lodash.get(vm.onLoadEventOptions, 'fileSize', (1024*1024*5))
                                if (e.files[0].size > fileSize) {
                                    // var wrapper = $element.parents('label');
                                    //
                                    // wrapper.addClass('error');
                                    // var msg = lodash.get(vm, 'element.validation.fileSize', 'File should not be greater than 2 MB');
                                    // wrapper.find('.error-message-wrapper').html("<div class='error-message'>" + msg + "</div>");
                                    e.preventDefault();

                                    var sizing =CommonHelper.bytesToSize( vm.onLoadEventOptions.fileSize);
                                    var limitFileMessage = lodash.get(vm, 'element.options.limitFileMessage', 'File should not be greater than');
                                    vm.pageData.elementsService.setValidationError(vm.element.elementIdentifier, [lodash.get(vm, 'element.validation.fileSize', limitFileMessage+' '+sizing)], true);
                                    $scope.$apply();
                                    return false;
                                }
                            }

                            if (lodash.has(vm.element, 'attr.sender_name')) {
                                e.sender.name = vm.element.attr.sender_name;
                            }
                            e.data = lodash.get(vm, 'element.attr.upload_data', {});
                        }
                    }
                );
            }
        }

        function quanKunDaMoYi() {
            $timeout(function () {
                var em = $element.find('.k-upload-button');
                $element.remove('.k-upload-button');
                $element.find('.k-upload').prepend(em);
            });
        }
    }
})();